var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.688,
    height: 26.5,
    viewBox: "0 0 18.688 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10240",
    "data-name": "Group 10240",
    transform: "translate(6418.25 19366.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7290",
    "data-name": "Path 7290",
    className: "cls-1",
    d: "M10.659,11.423l2.849-2.76a1.093,1.093,0,0,1,.63-.295,1.119,1.119,0,0,1,.921.294l2.85,2.761",
    transform: "translate(-6418.221 -19366.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7291",
    "data-name": "Path 7291",
    className: "cls-1",
    d: "M12.643,5.285A2.643,2.643,0,1,0,10,2.643,2.643,2.643,0,0,0,12.643,5.285Z",
    transform: "translate(-6416.51 -19365.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7295",
    "data-name": "Path 7295",
    className: "cls-1",
    d: "M13.255,6.51A3.255,3.255,0,1,0,10,3.255,3.255,3.255,0,0,0,13.255,6.51Z",
    transform: "translate(-6427.5 -19365.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7296",
    "data-name": "Path 7296",
    className: "cls-1",
    d: "M13.255,6.51A3.255,3.255,0,1,0,10,3.255,3.255,3.255,0,0,0,13.255,6.51Z",
    transform: "translate(-6427.5 -19347.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7297",
    "data-name": "Path 7297",
    className: "cls-1",
    d: "M15.764,9.9c0,.081.037,2.436,0,2.857a4.258,4.258,0,0,1-4.3,3.757h-5.9",
    transform: "translate(-6419.74 -19367.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7298",
    "data-name": "Path 7298",
    className: "cls-2",
    d: "M0,1V11.894",
    transform: "translate(-6414.245 -19359.953)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvWhite);
export default __webpack_public_path__ + "static/media/ivWhite.c2bf95c18721edfb55348bf00020c58d.svg";
export { ForwardRef as ReactComponent };